import { ProfileImage } from '@xing-com/profile-image';

import { Styled } from './article-card-header.styles';

export type ArticleCardHeaderType = {
  pageTitle: string;
  profileImage: string;
};

export const ArticleCardHeader: React.FC<ArticleCardHeaderType> = ({
  pageTitle,
  profileImage,
}) => (
  <Styled.Header>
    <ProfileImage
      src={profileImage}
      profileName={pageTitle}
      type="topic"
      size="xxsmall"
    />
    <Styled.Headline size="small" ellipsis forwardedAs="p">
      {pageTitle}
    </Styled.Headline>
  </Styled.Header>
);
